/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
export const ADDRESS_FIELD_LENGTH = {
	phone1: 32,
	fax1: 32,
	phone2: 32,
	fax2: 32,
	mobilePhone1: 32,
	zipCode: 40,
	personTitle: 50,
	field3: 64,
	field1: 64,
	field2: 64,
	logonId: 128,
	orgName: 128,
	lastName: 128,
	firstName: 128,
	middleName: 128,
	businessTitle: 128,
	address2: 128,
	address3: 128,
	city: 128,
	state: 128,
	country: 128,
	nickName: 254,
	address1: 256,
	email1: 256,
	email2: 256,
}; 

export const genderSpec = [
	{
	  code: "M",
	  displayName: "Man",
	},
	{
	  code: "F",
	  displayName: "Vrouw",
	},
	{
	  code: "U",
	  displayName: "Neutraal",
	}
   ];

   
const YEAR = new Date().getFullYear();
export const DATEOFBIRTH = {
	DAYS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12',
		   '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24',
		   '25', '26', '27', '28', '29', '30', '31'],
	MONTHS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	YEARS: Array(101)
		.fill(null)
		.map((_v, i) => `${YEAR - i}`),
};

export const CHILDREN_SELECT_COUNT = ['1','2','3','4','5','6','7','8','9','10'];